module.exports = __webpack_public_path__ + "static/media/reply-all.9115c21f.svg";